//This class was created just to make methods that returns time in the server and in the computer
//it also helps us to process time calculations
//The server is slower but cannot be tricked by changing the time on the PC or any device
//The computer is faster but can be changed by the user

class Time {


    /**
     * Gets the time from your Device and converts to the format 
     * YYYY-MM-DDTHH:mm
    **/
    static getComputerTimeDate = () => {

        function pad2(number) { return (number < 10 ? '0' : '') + number }
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const hour = date.getHours(), min = date.getMinutes();
        const today = year + "-" + pad2(month + 1) + "-" + pad2(day) + "T" + pad2(hour) + ":" + pad2(min);

        //Return the result in a string
        //Example of the final result
        //2022-01-01T03:50
        return today;
    }

    static getComputerTimeDateNormal = () => {

        function pad2(number) { return (number < 10 ? '0' : '') + number }
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const hour = date.getHours(), min = date.getMinutes();
        const today = year + "-" + pad2(month + 1) + "-" + pad2(day) + " At: " + pad2(hour) + ":" + pad2(min);

        //Return the result in a string
        //Example of the final result
        //2022-01-01 At: 03:50
        return today;
    }

    /**
     * Recieve a Date() object and converts to a string
     * 
     * @param  {} dateToConvert
     * 
     * example of the format
     * YYYY-MM-DDTHH:MM
     * 
     */
    static convertDate = (dateToConvert) => {
        function pad2(number) { return (number < 10 ? '0' : '') + number }
        const date = new Date(dateToConvert);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const hour = date.getHours(), min = date.getMinutes();
        const today = year + "-" + pad2(month + 1) + "-" + pad2(day) + "T" + pad2(hour) + ":" + pad2(min);

        //return the result in a string
        return today;
    }


    /**
     * Returns the current month as a string
     */
    static getMonth = () => {

        const date = new Date();
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const month = months[date.getMonth()];

        //return the result in a string
        return month;
    }

    //Gets the time for a server
    static getServerTime = async () => {

        const timeDateRequest = await fetch("https://worldtimeapi.org/api/timezone/America/Toronto");
        let timeDateResult = await timeDateRequest.json();
        const timeDate = timeDateResult.datetime;

        //return the result in a string
        return timeDate;

    }

    /**
     *  Returns seconds into 00:00:00 format
     * @param  {number} sec - number of seconds 
     */
    static convertSecondsToString = (sec) => {

        //Makes sure that 1 will be 01 not 1 
        function pad2(number) { return (number < 10 ? '0' : '') + number }

        const hours = Math.floor(sec / 3600)
        const minutes = Math.floor((sec % 3600) / 60)
        const seconds = Math.floor((sec % 3600) % 60)

        let result = pad2(hours) + ":" + pad2(minutes) + ":" + pad2(seconds);

        return result
        //HH:MM:SS
    }
    /**
     * Returns YYYY/MM/DD
     * @param  {} date a Date() Object
     */
    static makeNormalDate = (date) => {
        function pad2(number) { return (number < 10 ? '0' : '') + number }
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const result = year + "/" + pad2(month + 1) + "/" + pad2(day)

        //return the result in a string
        //YYYY/MM/DD
        return result;
    }
    /**
     * Returns YYYY-MM-DD
     * @param  {Date} date a Date() Object
     */
    static makeNormalDateToServer = (date) => {
        function pad2(number) { return (number < 10 ? '0' : '') + number }
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const result = year + "-" + pad2(month + 1) + "-" + pad2(day)

        //return the result in a string
        return result;
    }


    /**
     * Convert date to PM/AM Style
     * @param  {} date
     */
    static convertToAMnPM = (date) => {
        function pad2(number) { return (number < 10 ? '0' : '') + number }
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        let hour = date.getHours(), min = date.getMinutes();
        let amOrPm = 'AM';

        if (hour > 12) {
            hour -= 12;
            amOrPm = 'PM';
        }

        let result = year + "-" + pad2(month + 1) + "-" + pad2(day) + ' ' + pad2(hour) + ':' + pad2(min) + ' ' + amOrPm;

        if (result == 'NaN-NaN-NaN NaN:NaN AM') {
            result = 'Shift not finished'
        }

        //return the result in a string
        return result;
    }

    /**
     * 
     * Returns an Array with the PayrollDates
     *
     */
    static PayrollDates = (opts = {}) => {
        const { startISO = "2022-01-03", periodDays = 14, horizonYears = 2 } = opts;

        const toUTC = (iso) => new Date(iso + "T00:00:00Z");
        const addDaysUTC = (d, n) => {
            const x = new Date(d);
            x.setUTCDate(x.getUTCDate() + n);
            return x;
        };

        const dates = [];
        let start = toUTC(startISO);
        const horizonEnd = new Date();
        horizonEnd.setUTCFullYear(horizonEnd.getUTCFullYear() + horizonYears);

        while (start <= horizonEnd) {
            const end = addDaysUTC(start, periodDays - 1);
            const queryStart = this.makeNormalDateToServer(start);
            const queryEnd = this.makeNormalDateToServer(end);
            dates.push({
                value: { start: queryStart, end: queryEnd },
                label: `From ${this.makeNormalDate(start)} to ${this.makeNormalDate(end)}`
            });
            start = addDaysUTC(start, periodDays);
        }
        return dates;
    };

    /**
     * 
     * Returns all the valid holidays from Ontario in the current year
     * 
     * @return An array with the holidays
     */
    static getHolidays = async () => {

        let holidayList;

        //Call this API that returns all Holidays
        await fetch("https://canada-holidays.ca/api/v1/provinces")
            .then(response => response.json())
            .then(result => process(result))
            .catch(error => console.log('error', error));

        //Process the results
        function process(h) {

            //First we get only the holidays from Ontario
            const provinces = h.provinces;
            let ontarioHolidays;
            for (let province of provinces) {
                if (province.id === "ON") {
                    ontarioHolidays = province.holidays
                }
            }
            holidayList = ontarioHolidays;
        }

        return holidayList;
    }

    /**Calculate the average of hours worked in an array of shifts
     * @param  {} dates
     */
    static calculateAverageTimeWorked = (dates) => {

        let allHours = [];

        for (let date of dates) {
            let startingPeriod = new Date(date.HrStartTime);
            let finishPeriod = new Date(date.HrEndTime);

            let hoursDifference = finishPeriod - startingPeriod;

            hoursDifference = hoursDifference / 3.6e+6
            allHours.push(hoursDifference)
        }

        let totalHours = 0;
        for (let period of allHours) {
            if (isNaN(period)) {

            } else {
                totalHours += period;
                //console.log(period);
            }

        }

        let result = totalHours / allHours.length;

        if (dates.length == 0) {
            result = 0;
        }

        return result;

    }

}

export default Time;